import React, { useState } from 'react';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { AttachFile, BubbleChart, Close, Description, ImportContacts, Settings, Wallpaper } from '@mui/icons-material';
import chartingMenuSx from './ChartingMenu.styles';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../Chart.redux';
import { actions as fileActions } from 'components/FileManager/FileManager.redux';
import FileManager from 'components/FileManager';
import ReportsDialog from './ReportsDialog';
import NewReportDialog from './NewReportDialog';

const MenuExtras = () => {
    const theme = useTheme();
    const sx = chartingMenuSx(theme);
    const [anchor, setAnchor] = useState(null),
        dispatch = useDispatch(),
        selected = useSelector((state) => state.chart.toolbar.selectedButton === 'extras'),
        tool = useSelector((state) => state.chart.toolbar.selectedTool),
        reportModalStatus = useSelector((state) => state.chart.reportModalStatus),
        validTools = ['visitInfo'],
        visitID = useSelector((state) => state.chart.visit_id),
        clientID = useSelector((state) => state.chart.client_id),
        patientID = useSelector((state) => state.chart.patient_id);

    const handleClose = () => setAnchor(null),
        handleOpen = (e) => {
            setAnchor(e.currentTarget);

            let shouldUpdate = false,
                update = {};

            if (!selected) {
                shouldUpdate = true;
                update.selectedButton = '';
                update.selectedTool = null;
            }

            if (selected && validTools.includes(tool)) {
                shouldUpdate = false;
            }

            if (selected && !validTools.includes(tool)) {
                shouldUpdate = true;
                update.selectedTool = null;
            }

            if (shouldUpdate) {
                dispatch(actions.setToolbar(update));
            }
        },
        toggleTool = (name) => (e) => {
            dispatch(
                actions.setToolbar({
                    selectedTool: name,
                    selectedButton: 'extras',
                })
            );
            setAnchor(null);
        },
        handleReportsDialogClose = () => dispatch(actions.setState({ reportModalStatus: null })),
        handleNewReport = () => dispatch(actions.setState({ reportModalStatus: 'new' })),
        toolIcons = {
            markMissing: <Close />,
            probe: <BubbleChart />,
        };

    return (
        <>
            <Button
                variant={selected ? 'contained' : 'outlined'}
                color={selected ? 'primary' : undefined}
                sx={{ ...sx.buttonMarginRight, ...sx.buttonFloat }}
                startIcon={toolIcons[tool] !== undefined ? toolIcons[tool] : <Settings />}
                onClick={handleOpen}
            >
                Extras
            </Button>

            <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={handleClose}>
                <MenuItem onClick={toggleTool('visitInfo')} sx={tool === 'visitInfo' ? sx.activeItem : undefined}>
                    <ListItemIcon>
                        <ImportContacts />
                    </ListItemIcon>
                    <ListItemText>Visit Info</ListItemText>
                </MenuItem>

                <MenuItem
                    onClick={() => {
                        dispatch(fileActions.setState({ open: true, page: 'visit' }));
                        dispatch(fileActions.setBrowseOptions({ visit_id: visitID }));
                    }}
                >
                    <ListItemIcon>
                        <AttachFile />
                    </ListItemIcon>
                    <ListItemText>File Manager</ListItemText>
                </MenuItem>

                <MenuItem onClick={toggleTool('snapshot')} sx={tool === 'snapshot' ? sx.activeItem : undefined}>
                    <ListItemIcon>
                        <Wallpaper />
                    </ListItemIcon>
                    <ListItemText>Save Chart Image</ListItemText>
                </MenuItem>

                <MenuItem
                    onClick={() => {
                        dispatch(actions.setState({ reportModalStatus: 'list' }));
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        <Description />
                    </ListItemIcon>
                    <ListItemText>Reports</ListItemText>
                </MenuItem>
            </Menu>

            <FileManager visit_id={visitID} patient_id={patientID} client_id={clientID} />

            {reportModalStatus === 'list' && (
                <ReportsDialog handleClose={handleReportsDialogClose} handleNewReport={handleNewReport} />
            )}

            {reportModalStatus === 'new' && <NewReportDialog handleClose={handleReportsDialogClose} />}
        </>
    );
};

export default MenuExtras;
